import React from 'react';

const ArticleCard = ({ title, text, theme, imageSrc, webTagSrc, linkUrl, linkText }) => {
    return (
        <article className={`article-card article-card--${theme}`}>
            <figure className="article-card__figure">
                <img className="article-card__image" itemProp="image" src={imageSrc} alt={title} loading='lazy' />
            </figure>

            <a className='article-card__link' href={linkUrl} itemProp="url"></a>

            <div className="article-card__content">
                {webTagSrc && (
                    <figure className='article-card__webtag'>
                        <img src={webTagSrc} alt='webtag' loading='lazy' />
                    </figure>
                )}
                
                <h3 itemProp="name" className="article-card__title">{title}</h3>

                <div className='article-card__text' dangerouslySetInnerHTML={{ __html: text }}></div>
            </div>
        </article>
    )
}

export default ArticleCard;